// 获取咱们组件的基类，所有组件都要继承自这个类。
let Component = window.neplayer.lib.getComponent('Component')

const clarityOptions = [{
  label: '超清',
  value: '_1280',
  shortLabel: '超清',
}, {
  label: '高清',
  value: '_640',
  shortLabel: '高清',
}, {
  label: '标清',
  value: '_360',
  shortLabel: '标清',
}]

const channelOptions = [{
  label: '线路1',
  value: '1',
}, {
  label: '线路2',
  value: '2',
}]
function getLiveInfoInstance (initAudienceCount = 0, { displayTime = true, displayAmount = true }) {
  // nePlayer.extend  继承基类
  // 第二个参数是一个对象，包含createEl方法，这个方法中需要返回一个html元素
  // 这个组件元素在后面将被添加到播放容器中
  const LiveInfoComponent = window.neplayer.lib.extend(Component, {
    createEl: function () {
      var liveInfo = document.createElement('div')
      liveInfo.className = 'custom-plugin-live-info'
      liveInfo.innerHTML = ''
      if (displayTime) { liveInfo.innerHTML += '<span class="live-duration">已直播 00:00 </span>' }
      if (displayTime && displayAmount) { liveInfo.innerHTML += '<div class="vertical-split"></div>' }
      if (displayAmount) { liveInfo.innerHTML += '<span class="audience-amount"> ' + initAudienceCount + ' 人在线</span>' }
      return liveInfo
    },
  })

  let liveInfoComponent = new LiveInfoComponent()

  return liveInfoComponent
}

function getPlayButtonInstance () {
  const LiveInfoComponent = window.neplayer.lib.extend(Component, {
    createEl: function () {
      let pausingCoverStyle = {
        background: 'rgba(0, 0, 0, 0.5)',
        width: '100%',
        height: '100%',
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 999,
      }

      let pausingCover = document.createElement('div')
      pausingCover.className = 'custom-plugin-pause-cover'
      Object.assign(pausingCover.style, pausingCoverStyle)

      let playButton = document.createElement('div')
      playButton.className = 'custom-plugin-play-button'
      playButton.style.backgroundImage = 'url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmc'
      + 'vMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIGlkPSJDYXBhXzEiI'
      + 'Hg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMzAzLjk5IDMwMy45OSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMzA'
      + 'zLjk5IDMwMy45OTsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiBjbGFzcz0iIj48Zz48cGF0aCBzd'
      + 'HlsZT0iZmlsbDojRkZCODZEIiBkPSJNMTYxLjE3LDc1Ljk5bDkwLjQsNjIuNGMxLjYsMS4yLDMuMiwyLjQsNC40LDQuNGM1LjIsNy42LDM'
      + 'uMiwxNy42LTQsMjIuOGwtOTAuOCw2Mi40bC04OS4yLDYyICBjLTIuOCwyLjQtNi40LDMuNi0xMC40LDMuNmMtOS4yLDAtMTYuNC03LjItM'
      + 'TYuNC0xNi40di0xMjUuMlYyNi43OWwwLDBjMC0zLjIsMC44LTYuNCwyLjgtOS4yYzUuMi03LjYsMTUuMi05LjIsMjIuOC00ICBMMTYxLjE'
      + '3LDc1Ljk5eiIgZGF0YS1vcmlnaW5hbD0iI0Y2QTZBMSIgY2xhc3M9ImFjdGl2ZS1wYXRoIiBkYXRhLW9sZF9jb2xvcj0iI0ZGQjk2RSI+P'
      + 'C9wYXRoPjxwYXRoIHN0eWxlPSJmaWxsOiM1RjcxN0YiIGQ9Ik02MS41NywzMDMuOTljMy4yLDAsNi0wLjQsOC44LTEuNmMyLjgtMC44LDU'
      + 'uMi0yLjQsNy42LTRsODkuMi02MS42bDkwLTYyYzAuNC0wLjQsMS4yLTAuOCwxLjYtMS4yICBjNS42LTQsOS4yLTEwLDEwLjQtMTYuNGMxL'
      + 'jItNi40LDAtMTMuMi0zLjYtMTkuMmMtMC40LTAuNC0wLjgtMS4yLTEuMi0xLjZjLTAuOC0xLjItMS42LTItMi44LTMuMmMtMS4yLTEuMi0'
      + 'yLjQtMi40LTQtMy4ybDAsMCAgbC05MC40LTYyLjRsLTkwLjgtNjIuOGwwLDBjLTYtNC0xMy4yLTUuNi0yMC00LjRzLTEyLjgsNC44LTE3L'
      + 'jIsMTEuMmwwLDBjLTEuNiwyLjQtMi44LDQuOC0zLjYsNy4yYy0wLjgsMi0xLjIsNC0xLjIsNi40ICBjMCwwLjQsMCwxLjIsMCwxLjZ2MTI1'
      + 'LjJ2MTI1LjJjMCw3LjIsMi44LDE0LDgsMTguOGwwLDBDNDcuNTcsMzAwLjc5LDUzLjk3LDMwMy45OSw2MS41NywzMDMuOTl6IE01NS4xNyw'
      + 'xNTEuOTl2LTEyNCAgYzAtMC40LDAtMC44LDAtMS4ydi0wLjRjMC0wLjQsMC0wLjgsMC40LTEuMmMwLTAuNCwwLjQtMC44LDAuNC0xLjJjMC'
      + '0wLjQsMC40LTAuNCwwLjQtMC44YzAuOC0xLjIsMi40LTIsMy42LTJjMS4yLTAuNCwyLjgsMCw0LDAuOCAgYzAuNCwwLjQsMC44LDAuNCwxL'
      + 'jIsMC44bDkwLDYybDkwLjQsNjIuNGwwLDBsMCwwYzAuNCwwLjQsMC44LDAuNCwwLjgsMC44YzAuNCwwLjQsMC40LDAuNCwwLjgsMC44bDAs'
      + 'MGMwLjgsMS4yLDEuMiwzLjIsMC44LDQuNCAgYy0wLjQsMS42LTEuMiwyLjgtMi40LDRsMCwwbC05MCw2Mi40bC04OS42LDYyYy0wLjQsMC0'
      + 'wLjQsMC40LTAuOCwwLjRjLTAuNCwwLjQtMS4yLDAuOC0xLjYsMS4yYy0wLjgsMC40LTEuMiwwLjQtMiwwLjQgIGMtMS42LDAtMy4yLTAuOC'
      + '00LjQtMS42bDAsMGMtMS4yLTEuMi0xLjYtMi44LTEuNi00LjR2LTEyNS42SDU1LjE3eiIgZGF0YS1vcmlnaW5hbD0iIzVGNzE3RiIgY2xhc'
      + '3M9IiI+PC9wYXRoPjwvZz4gPC9zdmc+")'

      pausingCover.appendChild(playButton)
      return pausingCover
    },
  })

  let liveInfoComponent = new LiveInfoComponent()

  return liveInfoComponent
}

function getLoadingInstance () {
  const LoadingComponent = window.neplayer.lib.extend(Component, {
    createEl: function () {
      var loading = document.createElement('div')
      loading.className = 'custom-plugin-loading-wrap'
      loading.innerHTML = '<div class="loader-inner ball-clip-rotate-multiple"><div></div><div></div></div>'
        + '<div class="loading-tip">网络在溜号，全力唤醒中...</div>'
      return loading
    },
  })

  let loadingComponent = new LoadingComponent()

  return loadingComponent
}

function getChangeClarity (handleButtonClick, handleOptionsChoose, handleClose) {
  const ClarityComponent = window.neplayer.lib.extend(Component, {
    createEl: function () {
      // 打开默认显示的切换的按钮
      const button = document.createElement('div')
      button.className = 'custom-plugin-change-clarity-trigger'
      button.textContent = clarityOptions[0].shortLabel
      // 打开切换频道选择的窗口
      const wrap = document.createElement('div')
      wrap.className = 'custom-plugin-change-clarity-options'
      // 关闭窗口按钮
      const closeIcon = document.createElement('div')
      closeIcon.className = 'clarity-option-close ibang-close'
      // 选项
      const options = document.createElement('div')
      options.className = 'clarity-options'
      // 单个选项选择
      for (let i = 0, l = clarityOptions.length; i < l; i++) {
        const option = document.createElement('div')
        option.className = `clarity-option${i === 0 ? ' clarity-option_active' : ''}`
        option.textContent = clarityOptions[i].label
        option.dataset.shortLabel = clarityOptions[i].shortLabel
        option.addEventListener('click', e => {
          if (option.dataset.shortLabel !== button.textContent) {
            handleOptionsChoose && handleOptionsChoose(e, clarityOptions[i].value)
          }
          wrap.style.display = 'none'
          button.style.display = 'block'
          button.textContent = clarityOptions[i].shortLabel
          // 其他的option取消掉选中状态
          Array.prototype.forEach.call(options.querySelectorAll('.clarity-option'), item => {
            item.className = 'clarity-option'
          })
          option.className = 'clarity-option clarity-option_active'
          document.querySelector('#video-live_html5_api').style.filter = 'blur(0px)'
          handleClose && handleClose(e)
        })
        options.appendChild(option)
      }
      wrap.appendChild(closeIcon)
      wrap.appendChild(options)
      // 增加按钮点击事件，弹出选择窗口
      button.addEventListener('click', e => {
        e.stopPropagation()
        wrap.style.display = 'flex'
        button.style.display = 'none'
        document.querySelector('#video-live_html5_api').style.filter = 'blur(10px)'
        handleButtonClick && handleButtonClick(e)
      })
      // 增加选项关闭按钮操作事件
      closeIcon.addEventListener('click', e => {
        wrap.style.display = 'none'
        button.style.display = 'block'
        document.querySelector('#video-live_html5_api').style.filter = 'blur(0px)'
        handleClose && handleClose(e)
      })
      const dom = document.createElement('div')
      dom.appendChild(button)
      dom.appendChild(wrap)
      return dom
    },
  })
  return new ClarityComponent()
}

function getChangeChannel (handleButtonClick, handleOptionsChoose, handleClose) {
  const ChannelComponent = window.neplayer.lib.extend(Component, {
    createEl: function () {
      // 打开默认显示的切换的按钮
      const button = document.createElement('div')
      button.className = 'custom-plugin-change-channel-trigger'
      button.textContent = channelOptions[0].label
      // 打开切换频道选择的窗口
      const wrap = document.createElement('div')
      wrap.className = 'custom-plugin-change-channel-options'
      // 关闭窗口按钮
      const closeIcon = document.createElement('div')
      closeIcon.className = 'channel-option-close ibang-close'
      // 选项
      const options = document.createElement('div')
      options.className = 'channel-options'
      // 单个选项选择
      for (let i = 0, l = channelOptions.length; i < l; i++) {
        const option = document.createElement('div')
        option.className = `channel-option${i === 0 ? ' channel-option_active' : ''}`
        option.textContent = channelOptions[i].label
        option.addEventListener('click', e => {
          if (option.textContent !== button.textContent) {
            handleOptionsChoose && handleOptionsChoose(e, channelOptions[i].value)
            // 重置清晰度选择
            document.querySelector('.custom-plugin-change-clarity-trigger').textContent = clarityOptions[0].shortLabel
            //
            Array.prototype.forEach.call(document.querySelectorAll('.clarity-option'), (item, index) => {
              item.className = index === 0 ? 'clarity-option clarity-option_active' : 'clarity-option'
            })
          }
          wrap.style.display = 'none'
          button.style.display = 'block'
          button.textContent = channelOptions[i].label
          // 其他的option取消掉选中状态
          Array.prototype.forEach.call(options.querySelectorAll('.channel-option'), item => {
            item.className = 'channel-option'
          })
          option.className = 'channel-option channel-option_active'
          document.querySelector('#video-live_html5_api').style.filter = 'blur(0px)'
          handleClose && handleClose(e)
        })
        options.appendChild(option)
      }
      wrap.appendChild(closeIcon)
      wrap.appendChild(options)
      // 增加按钮点击事件，弹出选择窗口
      button.addEventListener('click', e => {
        e.stopPropagation()
        wrap.style.display = 'flex'
        button.style.display = 'none'
        document.querySelector('#video-live_html5_api').style.filter = 'blur(10px)'
        handleButtonClick && handleButtonClick(e)
      })
      // 增加选项关闭按钮操作事件
      closeIcon.addEventListener('click', e => {
        wrap.style.display = 'none'
        button.style.display = 'block'
        document.querySelector('#video-live_html5_api').style.filter = 'blur(0px)'
        handleClose && handleClose(e)
      })
      const dom = document.createElement('div')
      dom.appendChild(button)
      dom.appendChild(wrap)
      return dom
    },
  })
  return new ChannelComponent()
}

function getMessageTips (tipsMessage) {
  const MessageTips = window.neplayer.lib.extend(Component, {
    createEl: function () {
      var wrap = document.createElement('div')
      wrap.className = 'custom-message-tips'
      var clarityHTML = `<div class="tips-message">${tipsMessage}</div><div class="tips-close ibang-close"></div>`
      wrap.innerHTML = clarityHTML
      return wrap
    },
  })
  return new MessageTips()
}

export default {
  getLiveInfoInstance,
  getPlayButtonInstance,
  getLoadingInstance,
  getChangeClarity,
  getChangeChannel,
  getMessageTips,
}
